import { useQuery } from "@tanstack/react-query";
import { api } from "../../api/client";
import { endpoints } from "../../api/endpoints";
import type { ClergyPage } from "../../types/directory";

export interface ClergyQuery {
  search: string;
  /** One-based, unlike the Java services. */
  page: number;
  page_size: number;
  jurisdiction?: string;
  diocese?: string;
}

export function useClergy(query: ClergyQuery) {
  return useQuery({
    queryKey: ["clergy", query],
    queryFn: async () => {
      const params: Record<string, string | number> = {
        search: query.search,
        page: query.page,
        page_size: query.page_size,
      };
      if (query.jurisdiction) params.jurisdiction = query.jurisdiction;
      if (query.diocese) params.diocese = query.diocese;
      const { data } = await api.get<ClergyPage>(endpoints.clergy.list(), { params });
      return data;
    },
    placeholderData: (previous) => previous,
  });
}
